import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=daa2cc50&"
import script from "./AccountRegister.vue?vue&type=script&lang=js&"
export * from "./AccountRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports